export enum ContactPointEnum {
  TYPE = "ContactPoint",
  CONTACT_TYPE = "Customer Support",
  TELEPHONE = "+61 1800 319 370",
  EMAIL = "support@thevolte.com",
}
